module.exports = __webpack_public_path__ + "static/media/indexbg.024dfb3a.png";